module.exports = __webpack_public_path__ + "public/img/yibiaopan_lan_33.8e3ebfdf.png";